import { AdapterBase } from '@navix/utils/adapter'

export class ChargeCodesAdapter extends AdapterBase<unknown, unknown> {}
